import {Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material'
import {useTranslation} from 'react-i18next'
import CancelButton from '../../common/form/CancelButton'
import SpinnableSubmitButton from '../../common/form/SpinnableSubmitButton'
import TextInput from '../../common/form/TextInput'
import React, {useCallback} from 'react'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {useFormSubmission} from '../../common/servercall/useFormSubmission'
import ErrorAlert from '../../common/components/ErrorAlert'
import {api} from '../../common/api'
import {useWarningDialog} from "../../common/components/warning/useWarningDialog";
import {SoiRegistrationConfig, TrunkingSite} from "../../app/types";
import {emailRegex} from "../../users/UserForm";

type Props = {
    trunkingSite: TrunkingSite | undefined
    email: SoiRegistrationConfig | null
    handleClose: () => void
    onSuccess: () => void
}

type form = {
    email: string | null
}

const schema = yup
    .object()
    .shape({
        email: yup.string().trim().max(70, 'too-long').matches(
            emailRegex,
            'invalid-email'
        ).nullable(),
    })
    .required()

export const EmailDialog = ({trunkingSite, email, handleClose, onSuccess }: Props) => {
    const { t } = useTranslation()

    const { control, handleSubmit, setError } = useForm<form>({
        resolver: yupResolver(schema),
        defaultValues: { email: email?.email },
    })

    const {warningDialog: WarningDialog  } = useWarningDialog()

    const onSubmit = useCallback(
        async (formData: form) => {
            if (!trunkingSite) return
            await api.put(`/api/trunking/site/${trunkingSite.productId}/soi-registration-email`, {email: formData.email});
            onSuccess()
            handleClose()
        },
        [handleClose, onSuccess, trunkingSite]
    )

    const { submit, isSubmitting, serverError } = useFormSubmission<form>(onSubmit, setError)

    return (
        <>
            <WarningDialog />
            <Dialog open={!!email} onClose={handleClose}>
                <form onSubmit={handleSubmit(submit)}>
                    <DialogTitle>{t('trunking-sites.email.dialog.title')}</DialogTitle>
                    <DialogContent>
                        <ErrorAlert showAlert={!!serverError} />
                        <TextInput readonly={false} label={t('trunking-sites.e-mail')} name={'email'} control={control} required={false} />
                    </DialogContent>
                    <DialogActions>
                        <SpinnableSubmitButton label={t('trunking-sites.email.dialog.submit-button')} showSpinner={isSubmitting} />
                        <CancelButton onClick={handleClose} />
                    </DialogActions>
                </form>
            </Dialog>
        </>
    )
}
